import React from "react";
import {
	Button,
	CardFooter,
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Input,
} from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useMatchcodesContext } from "./MatchcodesContext";
import { ReactComponent as BackIcon } from "../../../../../assets/utils/images/svgs/arrow-left.svg";

export default function Footer() {
	const { adminCommunityList, setActiveTab, userTabs, filterCommunity } = useGebruikerContext();
	const { dropdownOpen, toggle, handleCheckboxChange } = useMatchcodesContext();
	return (
		<div className="chat-layout-footer">
			<CardFooter className="chat-layout-footer__inner gebruikers-footer">
				<div className="d-flex gap-3 w-100">
					<Dropdown isOpen={dropdownOpen} toggle={toggle}>
						<DropdownToggle className="form-select w-auto">Alle besturen</DropdownToggle>
						<DropdownMenu>
							{adminCommunityList.map((item) => {
								return (
									<DropdownItem
										key={item.iCommunityId}
										toggle={false}
										className="d-flex justify-content-between"
									>
										{item.vCommunityName}
										<Input
											type="checkbox"
											name={item.vCommunityName}
											value={item.iCommunityId}
											checked={filterCommunity.some(
												(community) =>
													community.iCommunityId === item.iCommunityId
											)}
											onChange={handleCheckboxChange}
										/>
									</DropdownItem>
								);
							})}
						</DropdownMenu>
					</Dropdown>
					<Button
						outline
						className="btn-outline-primary-blue ms-auto"
						onClick={() => {
							setActiveTab(userTabs.Beschikbaarheid);
						}}
						type="button"
						color="primary"
					>
						<BackIcon />
					</Button>
				</div>
			</CardFooter>
		</div>
	);
}
